export enum MappingStatus {
  Mapped,
  NotMapped,
  Blocked
}
